import m from "../../geodata/es2015/azerbaijanLow";
window.am4geodata_azerbaijanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/azerbaijanLow.js
// module id = null
// module chunks = 